var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2001 3.20001C2.77575 3.20001 2.36878 3.36858 2.06873 3.66864C1.76867 3.9687 1.6001 4.37567 1.6001 4.80001V8.00001C1.6001 8.42436 1.76867 8.83132 2.06873 9.13138C2.36878 9.43144 2.77575 9.60001 3.2001 9.60001V4.80001H11.2001C11.2001 4.37567 11.0315 3.9687 10.7315 3.66864C10.4314 3.36858 10.0244 3.20001 9.6001 3.20001H3.2001ZM4.8001 8.00001C4.8001 7.57567 4.96867 7.1687 5.26873 6.86864C5.56878 6.56858 5.97575 6.40001 6.4001 6.40001H12.8001C13.2244 6.40001 13.6314 6.56858 13.9315 6.86864C14.2315 7.1687 14.4001 7.57567 14.4001 8.00001V11.2C14.4001 11.6244 14.2315 12.0313 13.9315 12.3314C13.6314 12.6314 13.2244 12.8 12.8001 12.8H6.4001C5.97575 12.8 5.56878 12.6314 5.26873 12.3314C4.96867 12.0313 4.8001 11.6244 4.8001 11.2V8.00001ZM9.6001 11.2C10.0244 11.2 10.4314 11.0314 10.7315 10.7314C11.0315 10.4313 11.2001 10.0244 11.2001 9.60001C11.2001 9.17567 11.0315 8.7687 10.7315 8.46864C10.4314 8.16858 10.0244 8.00001 9.6001 8.00001C9.17575 8.00001 8.76879 8.16858 8.46873 8.46864C8.16867 8.7687 8.0001 9.17567 8.0001 9.60001C8.0001 10.0244 8.16867 10.4313 8.46873 10.7314C8.76879 11.0314 9.17575 11.2 9.6001 11.2Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/Cash.f31a998acc1ac169e340c682fee9043d.svg";
export { ForwardRef as ReactComponent };